module.exports = __webpack_public_path__ + "static/media/taric-black.80b7ef58.svg";